const formatNumber = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value);
  const [intPart, decPart] = str.split(".");
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
  return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
};

export default formatNumber;
